<template>
  <div :class="wrapClasses">
    <div class="flex px-4 pt-5 pb-4 sm:p-6">
      <div class="mx-auto flex flex-shrink-0 items-center justify-center h-12 w-12">
        <component :is="icon" class="h-12 w-12" :class="iconClass"></component>
      </div>
      <div class="text-center flex-grow sm:mt-0 sm:ml-4 sm:text-left">
        <h3 v-if="title" class="text-lg leading-6 font-medium" :class="titleColor">
          {{ title }}
        </h3>
        <div class="text-sm leading-5" :class="textColor + ' ' + pad">
          <slot></slot>
        </div>
      </div>
    </div>
    <div v-if="$slots['buttons']"
         class="bg-gray-100 border-t border-gray-200 px-4 py-3 sm:px-6 flex justify-center sm:flex sm:justify-end">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>
<script>
export default {
    name: "alert-box",
    props: {
        color: {type: String, default: "white"},
        icon: {type: String, default: "check-icon"},
        iconClass: {type: String, default: 'text-blue-600'},
        title: {type: String},
        maxWidth: {type: String, default: "sm:max-w-lg"},
        noBorder: {type: Boolean, default: false},
        pad: {type: String, default: 'mt-1'}
    },
    computed: {
        textColor() {
            switch (this.color) {
                case 'red':
                    return 'text-red-700';
                case 'yellow':
                    return 'text-yellow-700';
                case 'white':
                default:
                    return 'text-gray-600';
            }
        },
        titleColor() {
            switch (this.color) {
                case 'red':
                    return 'text-red-800';
                case 'yellow':
                    return 'text-yellow-800';
                case 'white':
                default:
                    return 'text-gray-900';
            }
        },
        wrapClasses() {
            if (this.noBorder) {
                return this.maxWidth;
            }
            let classes = this.maxWidth;
            switch (this.color) {
                case 'red':
                    classes += ' bg-red-100 border-red-200';
                    break;
                case 'yellow':
                    classes += ' bg-yellow-100 border-yellow-200';
                    break;
                case 'white':
                    classes += ' bg-white';
                    break;
            }
            return classes + ' border sm:rounded-lg overflow-hidden shadow sm:w-full';
        }

    }
}
</script>